export default "__VITE_ASSET__CCtQBdhi__"